/** @jsxImportSource ../i18n */
import React, { createContext, useContext, useState } from 'react';
import { setUILanguage } from '../i18n';

const LanguageContext = createContext();

// The language of the AI contents (sent to the backend) and of the
// interface (src/i18n): switching remounts the app so every text, memoized
// components included, is rendered again in the new language.
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem('insightsLang') || 'French';
    setUILanguage(stored);
    return stored;
  });

  const changeLanguage = (lang) => {
    setUILanguage(lang);
    setLanguage(lang);
    localStorage.setItem('insightsLang', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage }}>
      <React.Fragment key={language}>{children}</React.Fragment>
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
